import { useWizard } from "react-use-wizard";
import sellSteps from "../../sellSteps";
import {
  TKeyOfDataWizardSell,
  TStringKeysOfIFillDataWizardSell,
} from "../../..";
import { EDealRequestViewType } from "../../../../../../../shared/wizard/steps/types";
import ViewRealtorParticipationStep from "../../../../../../../shared/wizard/steps/viewRealtorParticipationStep";

interface IDoNotKnowPriceSellStep_4 {
  onChange: (
    data: EDealRequestViewType,
    key: TStringKeysOfIFillDataWizardSell
  ) => void;
  data: EDealRequestViewType | null;
  isNextStepDisabled: boolean;
  onReset: (key: TKeyOfDataWizardSell[]) => void;
}

const DoNotKnowPriceSellStep_4 = ({
  data,
  isNextStepDisabled,
  onChange,
  onReset,
}: IDoNotKnowPriceSellStep_4) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(sellSteps.doNotKnowPrice.sell.step_3);
    onReset(["viewRealtorParticipation"]);
  };

  const handleNexStep = () => {
    goToStep(sellSteps.doNotKnowPrice.sell.step_5);
  };

  return (
    <div>
      <ViewRealtorParticipationStep
        handlePrevStep={handlePrevStep}
        handleNexStep={handleNexStep}
        onChange={onChange}
        isNextStepDisabled={isNextStepDisabled}
        data={data}
        mode="sell"
      />
    </div>
  );
};

export default DoNotKnowPriceSellStep_4;
